module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-f1709153a0d1bfd65775844db21a1522.png";